import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import { addSongTopQueue } from '../../actions/player';

import PLAY_ICON from './play.svg';

export default class PlayTrackLink extends Component {
  _addToQueue() {
    this.props.dispatch(addSongTopQueue(this.props.track));
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <img src={PLAY_ICON} className={css(styles.icon)} />
        <div className={css(styles.text_container)} onClick={this._addToQueue.bind(this)}>
          Play song
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    color: Theme.primary,
    ':hover': {
      color: Theme.white,
    },
    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  text_container: {
    position: 'relative',
    fontFamily: Theme.fontFamily_secondary,
    fontWeight: 500,

    fontSize: 13,
    letterSpacing: 1,
    marginLeft: 15,
    marginRight: 15,
    cursor: 'pointer',
    transition: 'all 180ms ease-in-out',
    ':after': {
      position: 'absolute',
      opacity: 0,
      display: 'block',
      bottom: -10,
      left: 0,
      content: "' '",
      width: '100%',
      height: 2,
      transition: 'all 180ms ease-in-out',
      backgroundColor: Theme.white,
    },
    ":hover": {
      ':after': {
        bottom: -5,
        opacity: 1,
      },
    },
  },
  icon: {
    display: 'inline',
    width: 21,
    height: 21,
    marginLeft: 35,
    cursor: 'pointer',
    ':hover': {
      fill: Theme.primary,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/PlayTrackLink/index.js